module.exports = __webpack_public_path__ + "img/nota-codigo-el-eden.33467a77.png";